export default __webpack_public_path__ + "static/media/ps_08.504d02b8.png";